export const Code = ({ title, children }) => (
    <div className="overflow-hidden rounded-lg border border-slate-800 bg-slate-950/80">
        {title && (
            <div className="border-b border-slate-800 px-4 py-2 font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">
                {title}
            </div>
        )}
        <pre className="overflow-x-auto p-4 font-mono text-[11px] leading-relaxed text-slate-300">
            {children}
        </pre>
    </div>
);

export const Method = ({ m, path, children }) => (
    <div className="rounded-lg border border-slate-800/80 bg-[#111827] p-4">
        <div className="flex flex-wrap items-center gap-3 font-mono text-xs">
            <span
                className={`rounded border px-2 py-0.5 text-[10px] font-bold ${
                    m === "POST"
                        ? "border-cyan-500/30 bg-cyan-950 text-cyan-300"
                        : m === "GET"
                          ? "border-emerald-500/30 bg-emerald-950 text-emerald-300"
                          : "border-rose-500/30 bg-rose-950 text-rose-300"
                }`}
            >
                {m}
            </span>
            <span className="text-slate-200">{path}</span>
        </div>
        <div className="mt-2 text-xs leading-relaxed text-slate-400">{children}</div>
    </div>
);

export const DocSection = ({ id, title, children }) => (
    <section
        id={id}
        data-testid={`docs-section-${id}`}
        className="scroll-mt-24 border-b border-slate-800/60 py-12 first:pt-0 last:border-b-0"
    >
        <h2 className="font-display text-xl font-bold tracking-tight text-slate-100 sm:text-2xl">
            {title}
        </h2>
        <div className="mt-5 space-y-4 text-sm leading-relaxed text-slate-400">{children}</div>
    </section>
);

export const renderInline = (text) =>
    text.split(/(\*\*[^*]+\*\*|`[^`]+`)/g).map((p, i) => {
        if (p.startsWith("**") && p.endsWith("**"))
            return (
                <strong key={i} className="font-semibold text-slate-200">
                    {p.slice(2, -2)}
                </strong>
            );
        if (p.startsWith("`") && p.endsWith("`"))
            return (
                <code
                    key={i}
                    className="rounded bg-slate-900 px-1.5 py-0.5 font-mono text-[11px] text-cyan-300"
                >
                    {p.slice(1, -1)}
                </code>
            );
        return p;
    });

export const SourceBlocks = ({ source }) => {
    const out = [];
    source.split(/```/g).forEach((chunk, ci) => {
        if (ci % 2 === 1) {
            const nl = chunk.indexOf("\n");
            const title = chunk.slice(0, nl).trim();
            const code = chunk.slice(nl + 1).replace(/\n$/, "");
            out.push(
                <Code key={`c${ci}`} title={title || undefined}>
                    {code}
                </Code>,
            );
        } else {
            chunk
                .split(/\n\n+/)
                .map((p) => p.trim())
                .filter(Boolean)
                .forEach((p, pi) => {
                    const lines = p.split("\n");
                    if (lines.every((l) => l.startsWith(">> "))) {
                        out.push(
                            <div key={`m${ci}-${pi}`} className="space-y-3">
                                {lines.map((l, li) => {
                                    const m = l.slice(3).match(/^(\S+)\s+(\S+)\s*::\s*(.*)$/);
                                    if (!m) return null;
                                    return (
                                        <Method key={li} m={m[1]} path={m[2]}>
                                            {renderInline(m[3])}
                                        </Method>
                                    );
                                })}
                            </div>,
                        );
                    } else {
                        out.push(<p key={`p${ci}-${pi}`}>{renderInline(p)}</p>);
                    }
                });
        }
    });
    return out;
};
